import Page from "webPage/Page";
import CareersInfoModal from "modal/CareersInfoModal";
import $ from "jquery";
import Track from "util/Track";
import StickySection from "util/StickySection";

Page.register('page-template-careers', () => {
    $('body').on('click', '.js-careers-modal', function () {
        let data = JSON.parse($(this).parent().find('.js-modal-data').text());
        (new CareersInfoModal(data)).show();
        return false;
    }).on('click', '.js-modal-close', function () {
        $(this).parents('.modal').remove();
        $('body').removeClass('modal-active');
        return false;
    });

    let track = new Track($('.js-testimonials-track-wrap'), {
        classes: {
            block: "testimonials-track",
        },
    });


    $(document).bind('gform_post_render', function () {
        if ("undefined" !== typeof hcaptcha) {
            hcaptcha.render($('.h-captcha')[0]);
        }
    });

    if ($('.js-sticky-section').length > 0) {
        new StickySection($('.js-sticky-section'));
    }
});
